import React from 'react';
import PropTypes from 'prop-types';
import { XIcon, InfoIcon, WarningIcon, CheckCircleIcon } from '@phosphor-icons/react';

const Toast = ({
  variant = 'info',
  width = 'w-[300px]',
  showIcon = true,
  header,
  body,
  onClose,
  children,
  showArrow = false,
  headerClassName = '',
  position = 'bottom-center'
}) => {
  const variantStyles = {
    info: {
      backgroundColor: 'bg-info', borderColor: 'border-info', textColor: 'text-white', fillColor: 'white'
    },
    warning: {
      backgroundColor: 'bg-warning', borderColor: 'border-warning', textColor: 'text-black', fillColor: 'black'
    },
    alert: {
      backgroundColor: 'bg-alert', borderColor: 'border-alert', textColor: 'text-white', fillColor: 'white'
    },
    success: {
      backgroundColor: 'bg-success', borderColor: 'border-success', textColor: 'text-white', fillColor: 'white'
    },
    notification: {
      backgroundColor: 'bg-content2', borderColor: 'border-divider', textColor: 'text-default-900', fillColor: 'currentColor', boxShadow: 'shadow-lg'
    },
  };

  const style = variantStyles[variant];

  const icons = {
    info: <InfoIcon size={16} color={style.fillColor} />,
    warning: <WarningIcon size={16} color={style.fillColor} weight="fill" />,
    alert: <WarningIcon size={16} color={style.fillColor} weight="fill" />,
    success: <CheckCircleIcon size={16} color={style.fillColor} weight="fill" />,
    notification: <InfoIcon size={16} color={style.fillColor} className={style.textColor} />
  };

  const positionStyles = {
    'bottom-center': 'left-1/2',
    'bottom-left': 'left-[20px]',
    'bottom-right': 'right-[20px]',
  };

  return (
    <div className={`${width} ${showIcon ? 'p-2' : 'p-3'} ${style.backgroundColor} rounded-md border ${style.borderColor} flex ${style.boxShadow}`}>
      <div className='w-full flex flex-col'>
        <div className='w-full justify-between flex'>
          <div className='w-full justify-start items-center gap-2 flex'>
            {showIcon && icons[variant]}
            <div className={`${style.textColor} text-sm leading-5 ${showIcon ? 'font-normal' : 'font-bold'} ${headerClassName}`}>{header}</div>
          </div>
          {!!onClose && <XIcon size={16} color={style.fillColor} className={`shrink-0 ${style.textColor}`} style={{ cursor: 'pointer' }} onClick={onClose} />}
        </div>
        <div className={`flex flex-col ${showIcon && 'px-[28px]'}`}>
          <div className={`text-sm leading-5 font-normal pt-2 ${style.textColor}`}>{body}</div>
          {!!children && <div className='pt-4'>{children}</div>}
        </div>

      </div>
      {showArrow && <div className={`absolute -bottom-1 ${positionStyles[position]}  transform -translate-x-1/2`}>
        <div className={`w-2 h-2 ${style.backgroundColor}  left-0 bottom-0 transform rotate-45`}></div>
      </div>}
    </div>
  );
};

Toast.propTypes = {
  variant: PropTypes.oneOf(['info', 'warning', 'alert', 'success', 'notification']),
  header: PropTypes.string.isRequired,
  body: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node
};

export default Toast;
